import { useMutation } from "@tanstack/react-query";
import { _export } from "@synthesis/shared-services/internal/monitoring/client";
import { useDownload } from "@synthesis/shared-utils";
import dayjs from "dayjs";
import { getMonitoringRailwayQuery } from "../monitoring-page.lib";

export const useMonitoringExport = (railwayId: string) => {
  const download = useDownload();
  return useMutation({
    mutationFn: async () => {
      const response = await _export({
        query: { railway: getMonitoringRailwayQuery(railwayId) },
        responseType: "blob",
        validator: {},
      });
      const blob: unknown = response.data;
      if (!(blob instanceof Blob)) throw new Error("Invalid monitoring export response");
      download({ id: "monitoring", baseName: `Мониторинг_ВТУ_${dayjs().format("YYYY-MM-DD_HH-mm")}`, ext: "xlsx" }, blob);
    },
  });
};
